import { Box } from '@mui/material';
import React from 'react';

import { GovernancePolicyStepHeader } from './GovernancePolicyStepHeader';

interface StepContentProps {
    children: React.ReactNode;
    title: string;
    description: string;
}

export const GovernancePolicyStepContainer: React.FC<StepContentProps> = ({
    children,
    title,
    description,
}) => (
    <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    }}>
        <GovernancePolicyStepHeader
            title={title}
            description={description}
        />
        <Box
            data-cy="stepper-content"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}>
            {children}
        </Box>
    </Box>
);
